// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-68b97de5]:export {\n  blacker: #262626;\n  black: #333333;\n  white: #FFF;\n  red: #DC3545;\n  orange: #EB8D20;\n  yellow: #F7D601;\n  green: #14AF1B;\n  legacy-blue: #A5D8FF;\n  bay-blue: #2A3D92;\n  bay-blue-dark: #2B3990;\n  bay-blue-darker: #222E73;\n  neon-purple: #8400FF;\n  navbar-height-no-unit: 56;\n  top-toolbar-height-no-unit: 56;\n  md-min: 768;\n}", ""]);
// Exports
module.exports = exports;
